import './date';

export { default as debounce } from './debounce';

// eslint-disable-next-line @typescript-eslint/no-empty-function
export const voidCallback = (): void => {};
